export default __webpack_public_path__ + "static/media/product-image-25.39ddfd33.jpg";